import React, { useMemo, useState } from "react";
import PointsBankAPI from "./PointsBankAPI";
import "../shared/PageWrapper.css";

export default function CreateMissingPointsBank() {
  const pointsService = useMemo(() => new PointsBankAPI(), []);

  const [patientId, setPatientId] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const cleanedPatientId = String(patientId || "").trim();

    if (!cleanedPatientId) {
      setError("Please enter a patient ID.");
      setResult(null);
      return;
    }

    if (!/^\d+$/.test(cleanedPatientId)) {
      setError("Patient ID must be a number.");
      setResult(null);
      return;
    }

    setSubmitting(true);
    setError("");
    setResult(null);

    try {
      const response = await pointsService.createMissingPointsBank(cleanedPatientId);
      setResult(response);
      setPatientId("");
    } catch (err) {
      setError(err?.message || "Failed to create missing points bank.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="pageWrapper">
      <div className="formContainer">
        <h2>Create Missing Points Bank</h2>

        <p style={{ marginBottom: "1rem", color: "#555" }}>
          Use this only when a patient dashboard cannot load because the patient
          does not have a points bank row yet.
        </p>

        {error && (
          <div
            style={{
              padding: "10px",
              marginBottom: "1rem",
              borderRadius: "8px",
              background: "#ffe5e5",
              color: "#9b1c1c",
              border: "1px solid #f5b5b5",
            }}
          >
            {error}
          </div>
        )}

        {result && (
          <div
            style={{
              padding: "12px",
              marginBottom: "1rem",
              borderRadius: "8px",
              background: "#e7f8ec",
              color: "#155724",
              border: "1px solid #b9e8c4",
              textAlign: "left",
            }}
          >
            <h3 style={{ marginTop: 0 }}>Points Bank Ready</h3>

            <p>
              <strong>Message:</strong> {result.message}
            </p>

            <p>
              <strong>Points Bank ID:</strong> {result.pointsBankID}
            </p>

            <p>
              <strong>Patient ID:</strong> {result.patientId}
            </p>

            <p>
              <strong>Total Points:</strong> {result.totalPoints}
            </p>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="input-container">
            <input
              type="number"
              min="1"
              placeholder="Enter Patient ID"
              value={patientId}
              onChange={(e) => {
                setPatientId(e.target.value);
                setError("");
                setResult(null);
              }}
              required
            />
            <span className="tooltip">
              Enter the patient ID that is missing a points bank.
            </span>
          </div>

          <button type="submit" disabled={submitting}>
            {submitting ? "Creating..." : "Create Missing Points Bank"}
          </button>
        </form>
      </div>
    </div>
  );
}